import styled from '@emotion/styled';
import {css} from '@emotion/react';
import {colors, sizes} from 'patient-ping-remedy/packages/theme';

export const Wrapper = styled.div<{ isElevated?: boolean }>`
  position: sticky;
  top: 0;
  left: 0;
  z-index: 2;
  background: ${colors.purple1};

  ${({ isElevated }) => isElevated ? css`
    border-bottom: 2px solid ${colors.gray2};
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  ` : css`
    border-bottom: 1px solid ${colors.gray3};
  `};

  .client-demographics-edit {
    visibility: hidden;
  }

  &.open,
  &:hover {
    .client-demographics-edit {
      visibility: visible;
    }
  }
`;

export const Header = styled.div<{ isExpandable?: boolean }>`
  padding: ${sizes.xSmall} ${sizes.medium};

  ${({ isExpandable }) => isExpandable && css`
    &, * {
      cursor: pointer;
    }
  `}
`;

export const HeaderItems = styled.div`
  display: flex;
  align-items: center;
  gap: ${sizes.small};
`;

export const HeaderItem = styled.div`
  &:last-child {
    flex: 1;
  }
`;

export const HeaderArrow = styled.div`
  margin-right: -${sizes.xxSmall};
`;

export const Content = styled.div`
  padding: ${sizes.medium};
`;
